import { createAction } from 'redux-actions';

export const clearGuestNotes = createAction('CLEAR_GUEST_NOTES');
